import React from 'react';
import styled from 'styled-components';
import Imgix from 'shared/components/imgix';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { mediaQueries } from 'shared/styles';
import { ImgixDefaultSettings } from 'shared/constants';
import { tracker } from 'src/utils/analytics';
import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { GqlImageBanner } from 'types/graphql';
import { BannerImageWrapper } from './banner-image-wrapper';

const MenuImage = ({ banner, index }: { banner: GqlImageBanner; index: number }): JSX.Element => {
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down(`sm`));
  const { dispensary } = useDispensary();
  const flags = useFlags();

  const isAscendMenuStyleEnabled = flags['growth.ecomm.ascend-menu-style-hotfix.rollout'] ?? false;

  const loadingAttribute = index === 0 ? 'eager' : 'lazy';
  const target =
    banner.openInNewTab === null || typeof banner.openInNewTab === 'undefined' || banner.openInNewTab
      ? '_blank'
      : '_top';
  return (
    <BannerImageWrapper
      linkUrl={banner.link}
      rel={target === '_blank' ? 'noopener noreferrer' : null}
      target={target}
      onClick={() => tracker.imageBannerClicked({ dispensaryId: dispensary.id, dispensaryName: dispensary.name })}
    >
      <MainImage
        type='img'
        imgixParams={{
          ...ImgixDefaultSettings,
          crop: [`edges`],
          ar: isMobile ? '2.22:1' : '3:1',
          auto: 'compress',
          fm: 'webp',
        }}
        width={1200}
        height={400}
        htmlAttributes={{ alt: banner.alt, loading: loadingAttribute }}
        src={isMobile ? banner.mobileImage : banner.image}
        className={`product-image-${index}`}
        isAscendMenuStyleEnabled={isAscendMenuStyleEnabled}
      />
    </BannerImageWrapper>
  );
};

export default MenuImage;

const MainImage = styled(Imgix)<{ isAscendMenuStyleEnabled: boolean }>`
  aspect-ratio: 3/1 auto;
  border-radius: ${({ theme }) => theme.customized.radius.lg};
  display: block;
  object-fit: contain;
  width: 100%;

  @media ${mediaQueries.largePhone} {
    aspect-ratio: 2.22/1 auto;
    width: 100%;
    height: auto;
  }
`;
